<script setup>
import { get_subscriptions, submit_payment } from '@/services/subscriptions';
import { onMounted, ref } from 'vue';
import { priceFormat, swalError } from '@/helper';
import { retrieve_children } from '@/services/child';
import childSubCard  from './child_sub_card.vue'
import featureCard from './featureCard.vue'

const subscriptions = ref([])
const isLoading = ref(true)
onMounted(async ()=>{
  let response = await get_subscriptions()
  await getChildList()
  isLoading.value = false
  if (response.error){
    swalError(response.result, true)
    return
  }
  subscriptions.value = parseSubscription(response.result.data.data, response.result.data.included)
})

function parseSubscription(data, meta){
  data = data.map(item => {
    let temp_meta = []
    item.relationships.subscription_meta.data.forEach(x => {
      temp_meta.push(meta.find(i => i.id == x.id))
    })
    return {
      ...item,
      meta: temp_meta
    }
  })

  data.sort((a, b) => parseInt(a.attributes.price) - parseInt(b.attributes.price))
  return data
}

function get_meta(id, key){
  let subs = subscriptions.value.find(item=>item.id == id)
  let meta = subs.meta.find(item=>item.attributes.key == key)
  if (!meta){
    return ''
  }
  if (key == 'features'){
    return JSON.parse(meta.attributes.value)
  }
  return meta.attributes.value
}

async function subscribe(){
  let params = {
    subscription_id: selected.value.subscription_id, 
    child_id: selected.value.child, 
    return_url: window.location.origin
  }

  let response = await submit_payment(params)
  if (response.error){
    swalError(response.result, true)
    return
  }
  
  if (!response.result.success){
    swalError(response.result.error || 'Payment failed', true)
    return
  }
  
  localStorage.setItem('session_id', response.result.session_id)
  localStorage.setItem('payment_id', response.result.payment_id)
  location.replace(response.result.session_url)
}

const children = ref([])
async function getChildList(){
  let response = await retrieve_children()
  if (response.error){
    swalError(response.result, true)
    return
  }
  if (response.result.data.status.empty){
    children.value = []  
    return
  }
  children.value = response.result.data.children.data
}

const selected = ref({child: 0, subscription_id: ''})
function selectChild(subscribe_id){
  selected.value.subscription_id =  subscribe_id
}

const showChild = ref([])
function showSubsChild(sub_id){
  showChild.value.push(sub_id)
}

function closeChild(sub_id){
  let ind = showChild.value.findIndex(id => id == sub_id)
  showChild.value.splice(ind, 1)
}

function getSubTitle(sub_id){
  let tempSub = ''
  if (sub_id){
    tempSub = subscriptions.value.find(item => item.id == sub_id)
  }
  return tempSub.attributes?.title || ''
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Subcription Plan"/>
    <div v-auto-animate>

      <!-- Child Modal -->
      <div class="modal fade" id='editForm' tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm Subsription for {{ getSubTitle(selected.subscription_id) }}</h5>
              <button class="btn-close" type="button"
                data-bs-dismiss="modal" aria-label="Close"
              >
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <!-- <div class="col-6"> -->
                  <div class="card">
                    <div class="card-body p-0">
                      <form @submit.prevent="subscribe()">
                        <label for="select-form">
                          Select Child
                        </label>
                        <select class="form-select" aria-label="Select Child"
                          v-model="selected.child"
                        >
                          <option selected value="0">Please Select Child</option>
                          <option v-for="child in children" :key="child.id" 
                            :value="child.id"
                          >
                            {{ child.attributes.name }}
                          </option>
                        </select>
                        <!-- <div class="d-flex justify-content-end">
                          <button class="btn btn-primary mt-2" type="submit">
                            Subscribe Now!
                          </button>
                        </div> -->
                      </form>
                    </div>        
                  </div>
                <!-- </div> -->
              </div>
            </div>
            <div class="modal-footer">
              <button id='closeBtn' class="btn btn-light-danger" type="button" data-bs-dismiss="modal">Close</button>
              <button class="btn btn-light-success" type="button" @click="subscribe()">
                Subscribe Now!
              </button>
            </div>
          </div>
        </div>

        
      </div>

      <div class="row">
        <loadingCard v-if="isLoading" />
        <template v-else>
          <template v-if="subscriptions.length == 0">
            <EmptyCard />
          </template>
          <div v-else class="col-md-4 px-2" v-for="subscription in subscriptions">
            <div class="card" v-auto-animate>
              <div class="card-body" v-auto-animate>
                <template v-if="showChild.find(id => id == subscription.id)">
                  <childSubCard :subscribePackage="subscription"/>
                  <div class="d-flex justify-content-end">
                    <button class="btn btn-light-warning" @click=closeChild(subscription.id)>
                      Close
                    </button>
                  </div>
                </template>
                <template v-else>
                  <div>
                    <h5>{{ subscription.attributes.title }}</h5>
                    <p class="fs-1 mb-0">
                      <span v-if="subscription.attributes.price !== 0" 
                        class="fs-3 text-secondary"
                      >
                        RM 
                      </span>
                      {{ priceFormat(subscription.attributes.price) }}
                    </p>
                    <p class="mt-n4">for {{ get_meta(subscription.id, 'duration') }} days</p>
                    <p>{{ get_meta(subscription.id, 'description') }}</p>
                    <button class="btn btn-light-primary w-100"
                      data-bs-toggle="modal" data-bs-target='#editForm'
                      @click="selectChild(subscription.id)"
                    >
                      Get Started
                    </button>
                  </div>
                  <featureCard :subscription-package="subscription" />
                  <div class="text-center">
                    <button class="mt-3 btn btn-light-primary" @click="showSubsChild(subscription.id)">
                      View Subscribed Children
                    </button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>